module.exports = __webpack_public_path__ + "media/images/proof_links/colored/yandexmusic-500ac4c9d1d135e154eb7df944a4e958.svg";